var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNgc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F80000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5312 9.47362L7.76475 14.625L7.90369 10.4394H7.03125L7.38787 6.76519L11.3726 6.21619L10.0642 9.549L11.5312 9.47362ZM8.43862 13.1287V12.1444C8.43862 12.0712 8.37675 12.0116 8.30025 12.0116C8.22375 12.0116 8.16131 12.0707 8.16131 12.1438V13.1287C8.16131 13.2019 8.22319 13.2615 8.30025 13.2615C8.37731 13.2615 8.43862 13.2019 8.43862 13.1287ZM7.40813 10.1554H8.20125L8.16469 11.6702C8.16413 11.7101 8.17987 11.7489 8.20912 11.7771C8.23837 11.8052 8.27831 11.8221 8.31994 11.8221H8.32669C8.36631 11.8228 8.40466 11.8081 8.43356 11.781C8.46246 11.7539 8.47962 11.7165 8.48137 11.6769L8.51794 9.88988H7.72481L7.99088 6.95419C7.99369 6.92044 7.98188 6.88669 7.95769 6.86137C7.9335 6.83606 7.89975 6.822 7.86375 6.822H7.84125C7.81008 6.82137 7.77979 6.83237 7.75629 6.85286C7.73278 6.87334 7.71775 6.90185 7.71412 6.93281L7.40813 10.1554ZM7.40813 6.44288L8.87512 5.23125C8.95387 4.01906 8.16075 3.8295 8.16075 3.8295L8.28 3.375C9.58838 3.75356 9.39038 5.193 9.39038 5.193L11.2933 5.98837L7.40813 6.44288Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgc);
export default __webpack_public_path__ + "static/media/ngc.0fcbc54a56965fdc1290b73567992caa.svg";
export { ForwardRef as ReactComponent };